import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { incidentOperations } from '../../../redux/incident';
import { withRouter } from 'react-router-dom';
import { fetchResources209 } from '../../../esri/mapHub';
import DataGrid from '../../common/DataGrid';
import DataGridHeader from '../../common/DataGrid/DataGridHeader';
import {
  formatAttribute,
  applyFieldArrayOverrides
} from '../../../utils/helpers';

import DownloadAsCsvButton from '../../common/DownloadAsCsvButton';

import gridDefinition from '../../../defaults/datagrids/incident209Resources.json';
import originFields from '../../../defaults/PointOfOriginFields.json';

import theme from '../../../muiTheme';

class Resources209 extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      resources: [],
      fields: [],
      resourceCount: 0
    };
  }

  componentDidMount() {
    this.getResources(this.props.incident).then(state => {
      this.setState({
        ...state,
        loading: false,
        resourceCount: state.resources.length
      });
    });
    console.log(this.state);
  }

  updateResourceList = (resources, resourceCount, isMore) => {
    this.setState({ resources, resourceCount, isMore });
    this.resourcesHaveLoaded();
  };

  getAllFields() {
    const fieldInfos = this.state.fields;
    const fields = fieldInfos.map(field => {
      return { alias: field.alias, name: field.name, width: 250 };
    });

    return fields;
  }

  resourcesHaveLoaded = () => {
    this.setState({ loading: false });
  };

  resourcesAreLoading = () => {
    this.setState({ loading: true });
  };

  getResources(incident) {
    return new Promise((resolve, reject) => {
      const where = this.getBaseQuery();
      fetchResources209({ where }).then(
        response => {
          const resources = response.features.map(f => {
            return {
              attributes: f.attributes
            };
          });

          resolve({
            resources,
            fields: response.fields
          });
        },
        error => console.error(error)
      );
    });
  }

  getBaseQuery() {
    const id = originFields.idFields.incidents;
    const value = this.props.match.params.id;
    const baseClause = gridDefinition.baseQuery
      ? `AND (${gridDefinition.baseQuery})`
      : '';
    return `(${id} = '${value}') ${baseClause}`;
  }

  getCsvData = () => {
    //flatten features
    let flatIncidents = this.state.resources.map(featureObj => {
      const formattedAttributes = {};
      for (var key in featureObj.attributes) {
        if (featureObj.attributes.hasOwnProperty(key)) {
          const formattedAttribute = formatAttribute(
            key,
            featureObj.attributes[key],
            'incident209Resources',
            this.state.fields,
            true
          );
          const { name, value } = formattedAttribute;
          formattedAttributes[name] = value || '';
        }
      }
      return formattedAttributes;
    });

    return Promise.resolve(flatIncidents);
  };

  getDataGrid(loading, resources, fields) {
    if (!resources.length) return null;

    applyFieldArrayOverrides(fields, 'incident209Resources');

    return (
      <DataGrid
        api="incident209Resources"
        fieldDefinitions={this.getAllFields(fields)}
        fieldInfos={fields}
        items={resources}
        loading={loading}
        hidePagination={true}
        attributeFormatter={formatAttribute}
        static
      />
    );
  }

  render() {
    const { loading, resources, fields, resourceCount } = this.state;
    const mapLoaded = this.props.map.loaded;
    const incidentName = this.props.incident.attributes.IncidentName;

    if (!mapLoaded) {
      return null;
    }

    return (
      <Fragment>
        <div style={styles.headerWrapper}>
          <DataGridHeader
            title="Incident Resources"
            badgeColor={theme.palette.accent1Color}
            itemCount={resourceCount}
          />
          <DownloadAsCsvButton
            tooltip="Download 209 Resources as CSV"
            fields={fields}
            exportedFilename={`${incidentName}_resources.csv`}
            dataPromise={this.getCsvData}
          />
        </div>

        {this.getDataGrid(loading, resources, fields)}
      </Fragment>
    );
  }
}

const styles = {
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: '0 0 50px'
  }
};

const mapStateToProps = state => ({
  map: state.map,
  appConfig: state.config,
  resource209Fields: state.incident.resource209Fields,
  incident: state.incident.currentIncident,
  dataGridFilters: state.dataGridFilters
});

const mapDispatchToProps = function(dispatch) {
  return bindActionCreators(
    {
      ...incidentOperations
    },
    dispatch
  );
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Resources209)
);



// WEBPACK FOOTER //
// ./src/components/incidents/IncidentDetails/Resources209.js